import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {FacadeService} from "../../shared/service-facade/facade.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isBaskBrand$: Observable<boolean>;
  isDesktopView$: Observable<boolean>;
  debugVisible = environment.showDebugInfo;

  constructor(
    private facadeService: FacadeService
  ) {
    this.isDesktopView$ = this.facadeService.isDesktopView$;
    this.isBaskBrand$ = this.facadeService.isBaskBrand$;
  }

  ngOnInit(): void {}
}
